import { render, staticRenderFns } from "./AllergyKpisLayout.vue?vue&type=template&id=3966faa2&"
import script from "./AllergyKpisLayout.vue?vue&type=script&lang=js&"
export * from "./AllergyKpisLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3966faa2')) {
      api.createRecord('3966faa2', component.options)
    } else {
      api.reload('3966faa2', component.options)
    }
    module.hot.accept("./AllergyKpisLayout.vue?vue&type=template&id=3966faa2&", function () {
      api.rerender('3966faa2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/main-column/AllergyKpisLayout.vue"
export default component.exports